import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { usePost } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function CancelRFPButton({ reference }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const cancelRFP = usePost("rfps/cancel");

  async function handleSubmit() {
    try {
      const response = await cancelRFP({ reference });

      if (response.isSuccess) {
        publish("notification", "RFP Cancelled");
      } else {
        publish(
          "notification",
          <>
            Unable to cancel RFP
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
    } catch (e) {
      console.error(e, "error cancelling RFP");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button style={{ backgroundColor: "rgb(219,23,41)" }} onClick={() => setDialogOpen(true)}>
        Cancel
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Cancel RFP</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>Are you sure you want to cancel this RFP?</BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, Don't cancel
          </Button>
          <Button onClick={handleSubmit}>Yes, cancel RFP</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default CancelRFPButton;
